import { findActiveNavItem } from '@dittolive/anvil'
import { Container, PortalShell } from 'components/layout'
import paths from 'paths'
import { Suspense } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { useEmployeeGroupContext } from './context'
import { useEmployeeGroupNavSections } from './employeeGroupNavSections'

export default function EmployeeGroupManagementLayout() {
  const { name, slug } = useEmployeeGroupContext()
  const { pathname } = useLocation()
  const navSections = useEmployeeGroupNavSections(slug)

  const activeItem = findActiveNavItem(navSections, pathname)
  const pageName = activeItem?.breadcrumbText ?? activeItem?.text

  return (
    <PortalShell
      navSections={navSections}
      backTo={paths.userTenant({ area: 'employee-groups' })}
      backLabel="Employee groups"
      breadcrumbs={[{ text: name }, ...(pageName ? [{ text: pageName }] : [])]}
      showTenantBreadcrumb
      tenantBreadcrumbName="Personal"
    >
      <Container>
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </Container>
    </PortalShell>
  )
}
